import { PageHeader, PageHeaderProps } from 'main-layout/PageHeader';

import { isClusterWithOldK8s } from 'utils/cluster';
import { EksControlPlaneCostsAlert } from './EksControlPlaneCostsAlert';

import { useCluster } from '@cast/shared-cluster-context-data-access';

import { Stack } from '@cast/design-system';

export const PageHeaderWithClusterWarnings = ({
  ...pageHeaderProps
}: PageHeaderProps) => {
  const { cluster } = useCluster();

  const showAlert = isClusterWithOldK8s(cluster);

  return (
    <Stack gap={16} pb={24}>
      <PageHeader pb={0} {...pageHeaderProps} />
      {showAlert && <EksControlPlaneCostsAlert />}
    </Stack>
  );
};
